import React, { memo, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import CheckIcon from 'images/v5/icons/check.svg';
import DuplicateIcon from 'images/v5/icons/copy-01.svg';
import DollarIcon from 'images/v5/icons/currency-dollar.svg';
import DescriptionIcon from 'images/v5/icons/file-06.svg';
import TrashSvg from 'images/v5/icons/trash-03.svg';
import CloseSvg from 'images/v5/icons/x-close.svg';
import Button from 'layout/atoms/Button/Button';
import { openModal } from 'store/layoutSlice';
import { approveWarehouseRelease, cancelWarehouseRelease, completeWarehouseRelease, fetchWarehouseRelease, selectWarehouseReleaseDetailsItem, selectWarehouseReleaseDetailsStatus, selectWarehouseReleaseModel, } from 'store/warehouseReleaseDetailsSlice';
import { duplicateRelease, selectWarehouseReleasesStatus } from 'store/warehouseReleasesSlice';
import downloadFile from 'utils/downloadUtils';
function WarehouseReleaseAction() {
    const { i18n: { language }, t, } = useTranslation('warehouseReleases');
    const history = useHistory();
    const dispatch = useDispatch();
    const warehouseReleaseDetails = useSelector(selectWarehouseReleaseDetailsItem);
    const warehouseReleaseModel = useSelector(selectWarehouseReleaseModel);
    const releaseStatus = useSelector(selectWarehouseReleaseDetailsStatus);
    const status = useSelector(selectWarehouseReleasesStatus);
    const remove = useCallback(() => {
        dispatch(openModal({
            name: 'removeWarehouseRelease',
            data: {
                id: warehouseReleaseDetails.id,
                releaseId: warehouseReleaseDetails.releaseId,
                redirectTo: '/warehouse-releases',
            },
        }));
    }, [dispatch, warehouseReleaseDetails.id, warehouseReleaseDetails.releaseId]);
    const duplicate = useCallback(() => {
        dispatch(duplicateRelease(warehouseReleaseDetails.id))
            .unwrap()
            .then((response) => {
            dispatch(fetchWarehouseRelease(response));
            history.push(`/warehouse-releases/${response}`);
        });
    }, [dispatch, warehouseReleaseDetails.id, history]);
    const approve = useCallback(() => {
        dispatch(approveWarehouseRelease(warehouseReleaseDetails.id));
    }, [dispatch, warehouseReleaseDetails.id]);
    const cancel = useCallback(() => {
        dispatch(cancelWarehouseRelease(warehouseReleaseDetails.id));
    }, [dispatch, warehouseReleaseDetails.id]);
    const complete = useCallback(() => {
        dispatch(completeWarehouseRelease(warehouseReleaseDetails.id));
    }, [dispatch, warehouseReleaseDetails.id]);
    const [exporting, setExporting] = useState(false);
    const onClickExport = useCallback(() => {
        setExporting(true);
        downloadFile(`/export/getWarehouseReleaseComponentVariants/${warehouseReleaseDetails === null || warehouseReleaseDetails === void 0 ? void 0 : warehouseReleaseDetails.id}/${language}`).finally(() => setExporting(false));
    }, [language, warehouseReleaseDetails === null || warehouseReleaseDetails === void 0 ? void 0 : warehouseReleaseDetails.id]);
    const canApprove = warehouseReleaseDetails.allComponentVariantsReady &&
        warehouseReleaseDetails.sumOfModelQuantities > 0 &&
        (warehouseReleaseModel === null || warehouseReleaseModel === void 0 ? void 0 : warehouseReleaseModel.ready);
    return (React.createElement(React.Fragment, null,
        warehouseReleaseDetails.status === 'DRAFT' && [
            React.createElement("span", { key: "approve" },
                React.createElement(Button, { color: "primary", leftIcon: React.createElement(CheckIcon, null), onClick: approve, disabled: !canApprove, loading: releaseStatus.approve === 'loading' }, t('approve'))),
            React.createElement(Button, { key: "remove", color: "danger", leftIcon: React.createElement(TrashSvg, null), onClick: remove }, t('remove')),
        ],
        warehouseReleaseDetails.status !== 'DRAFT' && [
            React.createElement(Button, { key: "duplicate", leftIcon: React.createElement(DuplicateIcon, null), onClick: duplicate, loading: status.duplicate === 'loading' }, t('duplicate_as_draft')),
        ],
        warehouseReleaseDetails.status === 'APPROVED' && [
            React.createElement(Button, { key: "cancel", color: "danger", leftIcon: React.createElement(CloseSvg, null), onClick: cancel, loading: releaseStatus.cancel === 'loading' }, t('cancel')),
            React.createElement(Button, { key: "complete", color: "success", leftIcon: React.createElement(DollarIcon, null), onClick: complete, loading: releaseStatus.complete === 'loading' }, t('complete')),
        ],
        React.createElement(Button, { key: "export", leftIcon: React.createElement(DescriptionIcon, null), disabled: !(warehouseReleaseModel === null || warehouseReleaseModel === void 0 ? void 0 : warehouseReleaseModel.ready), loading: exporting, onClick: onClickExport }, t('export'))));
}
export default memo(WarehouseReleaseAction);
